import { type CompanyGroup } from "~/api/types";
import { getGroupInitials } from "~/helpers/companyGroups";
import { cn } from "~/lib/utils";

interface Props {
  group: Pick<CompanyGroup, "name" | "logoUrl">;
  className?: string;
}

export const CompanyGroupLogo = ({ group, className }: Props) => (
  <div
    className={cn(
      "bg-muted flex size-10 shrink-0 items-center justify-center overflow-hidden rounded-md border text-sm",
      className,
    )}
  >
    {group.logoUrl ? (
      <img
        src={group.logoUrl}
        alt={group.name}
        className="size-full object-contain"
      />
    ) : (
      <span className="text-muted-foreground font-medium">
        {getGroupInitials(group.name)}
      </span>
    )}
  </div>
);
